import React, { Component } from "react";
import CircleRow from "../../rows/CirclesRow";
import SquareRow from "../../rows/SquareRow";
import FiftyFiftyRows from "../../rows/fiftyFiftyRow/fiftyFiftyRow";
import Factoid from "../../rows/factoidRow/factoid";
import ImageGrid from "../../rows/ImageGrid";
import ButtonRow from "../../rows/ButtonRow";
import TextOnlyRow from "../../rows/textOnlyRow/textOnlyRow";
import RectangleRow from "../../rows/RectangleRow";
import CardRow from "../../rows/CardRow";
import MajorsMinors from "../../rows/majorsMinors/majorMinors";
import BlockStyle from "../../config/blockstyle";
import ScriptTag from "react-script-tag";
import Row from "../../containers/row";

class RowMaker extends Component {
  render() {
    console.log("ROW ->", this.props.row);
    const rowtype =
      typeof this.props.row.field_row_content !== "undefined"
        ? this.props.row.field_row_content[0]
        : this.props.row;
    const blockStyle =
      typeof this.props.row.field_block_style !== "undefined" &&
      this.props.row.field_block_style.name !== null
        ? this.props.row.field_block_style
        : BlockStyle.field_block_style;

    blockStyle["top"] = this.props.row.field_spacing_top;
    blockStyle["btm"] = this.props.row.field_spacing_btm;
    blockStyle["inner_top"] = this.props.row.field_inner_top;
    blockStyle["inner_btm"] = this.props.row.field_inner_btm;

    switch (rowtype.bundle) {
      case "majors_minors":
        return <MajorsMinors row={this.props.row} blockStyle={blockStyle} />;
      case "javascript_embed_p":
        console.log("WE HAVE JS ->");
        const script =
          typeof this.props.row.field_javascript_embed !== "undefined"
            ? this.props.row.field_javascript_embed
            : null;

        return (
          <Row>
            {typeof script.code !== "undefined" ? (
              <ScriptTag type="text/javascript">{script.code}</ScriptTag>
            ) : null}
            {typeof script.url !== "undefined" ? (
              <ScriptTag type="text/javascript" src={script.url} />
            ) : null}
            {typeof script.css !== "undefined" ? (
              <style
                dangerouslySetInnerHTML={{
                  __html: script.css,
                }}
              />
            ) : null}
            {typeof script.tag !== "undefined" ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: script.tag,
                }}
              />
            ) : null}
          </Row>
        );
      case "three_image_links":
        switch (rowtype.field_image_display) {
          case "circle":
            return (
              <CircleRow
                showTitle={this.props.row.field_boolean_2}
                title={this.props.row.field_text_1}
                item={this.props.row.item_id}
                rowData={rowtype.field_image_link}
                blockStyle={blockStyle}
                nudgeX={rowtype.field_image_link[0].field_integer_1}
                nudgeY={rowtype.field_image_link[0].field_integer_1}
              />
            );
          case "square":
            return (
              <SquareRow
                showTitle={this.props.row.field_boolean_2}
                title={this.props.row.field_text_1}
                item={this.props.row.item_id}
                rowData={rowtype.field_image_link}
                blockStyle={blockStyle}
              />
            );
          case "textless":
            return (
              <SquareRow
                showTitle={this.props.row.field_boolean_2}
                title={this.props.row.field_text_1}
                item={this.props.row.item_id}
                rowData={rowtype.field_image_link}
                blockStyle={blockStyle}
              />
            );
          case "rectangle":
            return (
              <RectangleRow
                showTitle={this.props.row.field_boolean_2}
                itle={this.props.row.field_text_1}
                item={this.props.row.item_id}
                rowData={rowtype.field_image_link}
                blockStyle={blockStyle}
              />
            );
          default:
            return (
              <p>
                Unknown Version of Three Image links:{" "}
                {rowtype.field_image_display}
              </p>
            );
        }
      case "50_50_band":
        return (
          <FiftyFiftyRows
            token={this.props.token}
            item={this.props.row.item_id}
            row={this.props.row}
            className={this.props.row.bundle}
            blockStyle={blockStyle}
          />
        );
      case "button_row":
        return (
          <ButtonRow
            item={this.props.row.item_id}
            row={this.props.row}
            blockStyle={blockStyle}
            token={this.props.token}
          />
        );
      case "title_with_description":
        const bgi =
          typeof this.props.row.field_image !== "undefined"
            ? this.props.row.field_image
            : "";
        return (
          <TextOnlyRow
            item={this.props.row.item_id}
            data={this.props.row}
            bgimage={bgi}
            title={this.props.row.field_text_1}
            className={this.props.row.bundle}
            blockStyle={blockStyle}
          />
        );
      case "factoid":
        return (
          <Factoid
            factoid={rowtype.field_factoids}
            row={this.props.row}
            blockStyle={blockStyle}
          />
        );
      case "image_grid":
        return (
          <ImageGrid
            showTitle={this.props.row.field_boolean_2}
            title={this.props.row.field_text_1}
            item={this.props.row.item_id}
            rowData={rowtype.field_images}
            blockStyle={blockStyle}
            gridSize={rowtype.field_max_grid_width}
          />
        );
      case "card_queue":
        return (
          <CardRow
            cardQueue={this.props.row.field_row_content[0].field_card_queue}
          />
        );
      default:
        return <p>Unknown bundle: {rowtype.bundle}</p>;
    }
  }
}

export default RowMaker;
